module.exports = new __parcel__URL__("king.e40a5e2a.webp").toString();